// src/modules/requerimiento/components/adicion/EquiposAInstalar.jsx
import React from "react";
import { Box, Button, Card, CardContent, LinearProgress, Typography } from "@mui/material";
import MemoryIcon from "@mui/icons-material/Memory";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

const AZUL_EQUIPOS = "#0284C7";
const AZUL_EQUIPOS_OSCURO = "#075985";

/**
 * Tarjeta "Equipos a instalar" (igual que en la app Android): cuántos equipos lleva el
 * requerimiento y el botón para buscar/asignar otro. La lista de equipos no va acá: cada uno
 * aparece abajo, en Trabajo de campo, con su "Instalar en vehículo".
 */
export default function EquiposAInstalar({ total = 0, loading = false, onBuscar }) {
  return (
    <Card variant="outlined" sx={{ borderRadius: "10px", mt: 2 }}>
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
          <Box
            sx={{
              width: 44, height: 44, borderRadius: "8px", color: "#fff", display: "grid", placeItems: "center", flexShrink: 0,
              background: `linear-gradient(135deg, ${AZUL_EQUIPOS}, ${AZUL_EQUIPOS_OSCURO})`,
            }}
          >
            <MemoryIcon />
          </Box>
          <Box sx={{ flex: 1, minWidth: 180 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>Equipos a instalar</Typography>
            <Typography variant="body2" color="text.secondary">
              {loading
                ? "Cargando…"
                : total === 0
                  ? "Escanea el código de barras del equipo o búscalo por IMEI, serie o modelo. Después indicas en qué vehículo lo instalaste."
                  : total === 1 ? "1 equipo asignado" : `${total} equipos asignados`}
            </Typography>
          </Box>
          <Button
            variant={total === 0 ? "contained" : "outlined"}
            startIcon={total === 0 ? <SearchIcon /> : <AddIcon />}
            onClick={onBuscar}
            sx={{ textTransform: "none", fontWeight: 700, py: 1 }}
          >
            {total === 0 ? "Buscar equipo" : "Agregar otro equipo"}
          </Button>
        </Box>
        {loading && <LinearProgress sx={{ mt: 1.5 }} />}
      </CardContent>
    </Card>
  );
}
